export default __webpack_public_path__ + "static/media/Logo.47461361.svg";